class VariantRadios extends HTMLElement {
  constructor() {
    super();

    this.timeoutID;
    this.isChanging = false;
    this.productForm = document.forms[this.getAttribute('form-id')];
    this.submitButton = this.productForm.querySelector('[type="submit"]');

    this.allOption1s = this.querySelectorAll('[data-variant-option="1"]');
    this.allOption2s = this.querySelectorAll('[data-variant-option="2"]');

    // get initial options
    if (this.allOption1s) {
      this.selectedOption1 = Array.from(this.allOption1s).find(radio => radio.checked).value;
    }

    if (this.allOption2s.length) {
      this.selectedOption2 = Array.from(this.allOption2s).find(radio => radio.checked).value;
    }

    this.updateOptions();
    this.highlightOptions('init');

    // for mobile view, there is a popover that is extracted from the body, so we have to listen for this event in theme.js Popover class
    window.addEventListener('popover:leave', this.timeoutVariantChange.bind(this), { once:true });
  }

  timeoutVariantChange(event) {
    if (!event) return;

    // for mobile, it takes longer to get the page elements
    const timeout = (event.detail.size === 'md') ? 25 : 500;

    this.timeoutID = setTimeout(() => {
      this.onVariantChange(event.detail.event);
    }, timeout);
  }

  onVariantChange(event) {
    if (!event) return;

    if (event) {
      this.selectedVariantOption = event.target.value;
      this.selectedVariantOptionIndex = +event.target.dataset.variantOption;
    }

    this.updateMasterId();
    this.highlightOptions('change');
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateURL();

    clearTimeout(this.timeoutID);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.variantOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.findActiveVariant();
  }

  dispatchVariantChange(htmlFragment) {
    this.productForm.dispatchEvent(new CustomEvent('product:rerender', {
      detail: {
        htmlFragment,
        variant: this.currentVariant,
      },
    }));
    this.productForm.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      variant: this.currentVariant,
      detail: {
        variant: this.currentVariant,
      },
    }));
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions(type) {

    // create an object of the available variant options2. We don't need 1 or 3 because the first options are always available in some configuration or other and the last one is based on what is left after a customer selects 1 and 2.
    const variantOptions2Array = [];
    this.allOption2s.forEach((input) => {
      variantOptions2Array.push(input.value);
    });

    this.activeItem = '';

    // on load, set initial option
    if (!this.selectedVariantOptionIndex) this.selectedVariantOptionIndex = 1;

    // we don't check for clicks on the 3rd option
    if (this.selectedVariantOptionIndex !== 3) {

      // disable the input options. We re-enable them based on availability
      if (this.selectedVariantOptionIndex === 1) {
        this.allOption2s.forEach((optionValue) => {
          optionValue.classList.add('disabled');
          optionValue.setAttribute('disabled', true);
          optionValue.checked = false;
        });
      }

      // always disable option3s and only enable the available ones
      this.querySelectorAll('[data-variant-option="3"]').forEach((optionValue) => {
        optionValue.classList.add('disabled');
        optionValue.setAttribute('disabled', true);
        optionValue.checked = false;
      });

      if (type === 'change') {
        // set the selected option1
        if (this.selectedVariantOptionIndex === 1) this.selectedOption1 = this.selectedVariantOption;
        if (this.selectedVariantOptionIndex === 2) this.selectedOption2 = this.selectedVariantOption;
      }

      // Filter the variants based on the first selected option
      const initialOptionsArray = this.getVariantData().filter(variant => variant.option1 === this.selectedOption1);
      let leftOverOptionsArray = initialOptionsArray.filter(variant => variant.option2 === this.selectedOption2);

      // in case the latest option2 is not available for option2, reset it
      if (leftOverOptionsArray.length === 0) {
        this.selectedOption2 = initialOptionsArray[0].option2;
        leftOverOptionsArray = initialOptionsArray.filter(variant => variant.option2 === this.selectedOption2);
      }
      else {
        if (this.variantOptions.length === 3) {
          this.activeItem = leftOverOptionsArray.filter(variant => variant.option3 === this.variantOptions[2])[0];
        }
      }

      initialOptionsArray.forEach((variant) => {

        // first option is clicked or on init
        if (this.selectedVariantOptionIndex === 1) {

          // only one variant option with multiple options
          if (variantOptions2Array.length === 0) {
            this.currentVariant = leftOverOptionsArray[0];
            return;
          }

          // loop through all options2 and enable the ones that are available for option1
          variantOptions2Array.forEach((option) => {
            if (variant.option2 === option) {
              this.enableOptions(2, option, null);
            }
          });

          if (leftOverOptionsArray.length === 0) return;

          // load the 3rd options based on the selected first and second option
          leftOverOptionsArray.forEach((leftOverVariant, index) => {
            this.enableOptions(3, leftOverVariant.option3, index, leftOverVariant);
          });
        }

        // second option is clicked
        if (leftOverOptionsArray.length === 0) return;

        if (this.selectedVariantOptionIndex === 2 && variant.option2 === this.selectedOption2) {
          leftOverOptionsArray.forEach((leftOverVariant, index) => {
            this.enableOptions(3, leftOverVariant.option3, index, leftOverVariant);
          });
        }
      });
    }

    this.updateOptions();
    this.currentVariant = this.findActiveVariant();
  }

  findActiveVariant() {
    return this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.variantOptions[index] === option;
      }).includes(false);
    });
  }

  enableOptions(optionNumber, value, index, variant) {
    const input = this.querySelector(`input[value="${value}"][data-variant-option="${optionNumber}"] `);

    if (!input) return;

    input.removeAttribute('disabled');
    input.classList.remove('disabled');

    if (optionNumber === 2) {
      if (input.value === this.selectedOption2) {
        input.checked = true;
      }
    }

    if (optionNumber === 3) {
      if (index === 0) {
        this.currentVariant = variant;
        if (this.activeItem === '' || !this.activeItem) {
          input.checked = true;
        }
      }
      if (this.activeItem?.option3 === value) {
        input.checked = true;
      }
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  renderProductInfo() {
    this.submitButton.setAttribute('disabled', true);

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then(response => response.text())
      .then((responseText) => {
        const newContent = document.createRange().createContextualFragment(responseText);
        this.dispatchVariantChange(newContent);
      })
      .finally(() => {
        Shopify?.PaymentButton?.init();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}